import { RESIZE_URL } from 'utils/restapi';

export const toThousandSeparator = value => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const modifyPrice = price => {
  const _price = parseFloat(price).toFixed(2);
  if (_price % 1 === 0) {
    return Math.floor(Number(_price));
  }
  return _price;
};

export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};


/**
 * performDownload function
 */

export const performDownload = (fileName, fileContent) => {
  if (fileContent === 'no data') {
    return false;
  }
  const blob = new Blob([fileContent]);
  // create hidden link
  const element = document.createElement('a');
  document.body.appendChild(element);
  element.setAttribute('href', window.URL.createObjectURL(blob));
  element.setAttribute('download', fileName);
  element.style.display = '';
  element.click();
};


// This function returns the correct URL to the avatar and the cover picture, depending on the format in which the user installed the picture on the avatar and cover. All this is done so that the user can use the avatar in GIF format

export const getImageUrl = (me, isCover) => {
  let avatarUrl = (me && me.avatar) || null;
  let coverUrl = (me && me.cover) || null;

  if (isCover) {
    if (coverUrl && coverUrl.endsWith('.gif')) {
      return coverUrl;
    }
    return `${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=264,h=300/${coverUrl}`;
  }

  if (avatarUrl && avatarUrl.endsWith('.gif')) {
    return avatarUrl;
  }
  return `${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=200/${avatarUrl}`;
};